const locale = {
	// #region People fields
	DETAILS_PEOPLE_FIELD_TITLE: 'Titolo',
	DETAILS_PEOPLE_FIELD_NAME: 'Nome',
	DETAILS_PEOPLE_FIELD_SURNAME: 'Cognome',
	DETAILS_PEOPLE_FIELD_STATUS: 'Stato Persona',
	DETAILS_PEOPLE_FIELD_TYPE: 'Tipo Persona',
	DETAILS_PEOPLE_FIELD_ASSIGNED_USER: 'Utente assegnato interno',
	DETAILS_PEOPLE_FIELD_ASSIGNED_USER_2: 'Utente assegnato esterno',
	DETAILS_PEOPLE_FIELD_BIRTHDAY: 'Compleanno',
	DETAILS_PEOPLE_FIELD_WARNING: 'Warning',
	DETAILS_PEOPLE_FIELD_BLOCKED: 'Bloccato',
	DETAILS_PEOPLE_FIELD_TAGS: 'Tag',
	DETAILS_PEOPLE_FIELD_COMPANY: 'Azienda',
	DETAILS_PEOPLE_FIELD_MARKETINGACTION: 'Azione Marketing padre',
	DETAILS_PEOPLE_FIELD_COMMERCIALCAMPAIGN: 'Campagna commerciale padre',
	DETAILS_PEOPLE_FIELD_LEADCHANNEL: 'Canale Lead origine',
	DETAILS_PEOPLE_FIELD_BROKER_COMPANY: 'Segnalatore - Azienda',
	DETAILS_PEOPLE_FIELD_BROKER_PERSON: 'Segnalatore - Persona',
	// #endregion

	// #region User Avatar
	PEOPLE_AVATAR_SECTION: 'Avatar',
	PEOPLE_AVATAR_SUBHEADER: "Visualizza o aggiorna l'avatar della persona"
	// #endregion
};

export default locale;
